module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.showEndMessage) ? _c('a-entity', {
    attrs: {
      "position": "0 0 -2"
    }
  }, [_c('a-entity', {
    attrs: {
      "id": "end-message-logo",
      "geometry": "primitive: plane; height: 1; width: 1;",
      "material": "shader: flat; flatShading: true; opacity: 0; src: #logo-end-message; transparent: true;",
      "position": "0 0.5 0"
    }
  }, [_c('a-animation', {
    attrs: {
      "attribute": "material.opacity",
      "delay": "1000",
      "to": "1"
    }
  })], 1), _vm._v(" "), _c('a-entity', {
    attrs: {
      "id": "end-message-text",
      "scale": "3 3 3",
      "text": 'opacity: 0; align: center; value:' + _vm.message + ';',
      "position": "0 -0.5 0"
    }
  }, [_c('a-animation', {
    attrs: {
      "attribute": "text.opacity",
      "delay": "2000",
      "to": "1"
    }
  })], 1)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e460613a!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/EndMessage.vue
// module id = 189
// module chunks = 2